import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Button from "../Global/Buttons/Button";
import Icon from "../Global/Icons/Icon";

const FolderSearchBar = ({ searchValue, onSearchChange, onClearClick }) => {
    const searchClearClasses = classnames(`folder-search folder-search--clear`, {
      'folder-search--clear-hide': !searchValue
    });

    return (
        <div className="folder-search">
          <input
              id="folder-search--search-bar"
              type="search"
              placeholder="Search"
              className="folder-search"
              onChange={onSearchChange}
              value={searchValue}
          />
          <Button
            onClick={onClearClick}
            classes={searchClearClasses}
            disabled={!searchValue}
            faux
          >
            <Icon name="close" size="xs" />
          </Button>
        </div>
    );
};

FolderSearchBar.propTypes = {
    searchValue: PropTypes.string,
    onSearchChange: PropTypes.func.isRequired,
    onClearClick: PropTypes.func.isRequired,
};

export default FolderSearchBar;


// WEBPACK FOOTER //
// ./library/app/components/Folders/FolderSearchBar.js